import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { IContract } from '@models/contract.class';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';
import { AppState, BLOTTER_FILTER, TRACKING_EVENTS, USER_ROLES } from 'src/app';
import { BootstrapService, MixpanelService, TradeService } from 'src/core';

@Component({
  selector: 'hb-blotter',
  templateUrl: './blotter.component.html',
  styleUrls: ['./blotter.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class BlotterComponent implements OnDestroy, OnInit {
  public downLoadExcel = 0;
  public downLoadExcelFund = 0;
  public downLoadExcelCash = 0;
  public standardUser = false;
  public isUserGlobal = false;
  public isRefreshing = false;
  public isUsaContract: boolean;
  public bootstrapPromise: Promise<any>;
  public filterText = '';

  public showRefreshTooltip = false;
  public refreshIsDisabled = false;
  public DISABLED_REFRESH_TIME = 3000;

  public selectedTab = 0;

  private currentContract: string;
  private subscriptions = new Subscription();

  constructor(
    private store: Store<AppState>,
    private bootstrapService: BootstrapService,
    private tradeService: TradeService,
    private mixpanelService: MixpanelService,
  ) {}

  ngOnInit() {
    this.mixpanelService.track(
      TRACKING_EVENTS.screen_orders.event,
      TRACKING_EVENTS.screen_orders.success,
    );
    this.bootstrapPromise = this.bootstrapService.initSession().then(() => {
      this.subscriptions.add(
        this.store
          .select('currentContract')
          .pipe(
            map((values: any) => values.toJS()),
            filter((contractId: any) => contractId !== undefined),
            distinctUntilChanged(),
          )
          .subscribe((contract: IContract) => {
            this.currentContract = contract.contractID;
            this.isUsaContract = contract.isUsa;
            this.selectedTab = 0;
            this.toggleTradeBlotter(true);
          }),
      );
    });

    this.toggleTradeBlotter(true);
    this.scanForUserRole();
    this.scanForUserTypeContract();
  }

  ngOnDestroy() {
    this.toggleTradeBlotter(false);
    this.subscriptions.unsubscribe();
  }

  public scanForUserTypeContract() {
    this.subscriptions.add(
      this.store.select('userGlobal').subscribe((value: boolean) => {
        this.isUserGlobal = value;
      }),
    );
  }

  public scanForUserRole() {
    this.subscriptions.add(
      this.store
        .select('userRole')
        .pipe(filter((value: any) => value !== undefined))
        .subscribe((value: any) => {
          this.standardUser =
            value === USER_ROLES.RI ||
            value === USER_ROLES.SUBDIRECTOR ||
            value === USER_ROLES.READONLY
              ? false
              : true;
        }),
    );
  }

  public changeFilter(event: any): void {
    this.store.dispatch({
      type: BLOTTER_FILTER,
      payload: event,
    });
  }

  changeView(index: any): void {
    this.selectedTab = index;
    this.refreshIsDisabled = false;
  }

  public toggleTradeBlotter(isVisible: boolean) {
    const tradeBlotter = document.getElementsByClassName('trade-blotter');
    Array.from(tradeBlotter).forEach((value: any) => {
      (value as HTMLElement).style.display = isVisible ? 'none' : 'block';
    });
  }

  public refresh() {
    if (!this.refreshIsDisabled) {
      this.isRefreshing = true;
      this.refreshIsDisabled = true;

      switch (this.selectedTab) {
        case 0:
          this.subscriptions.add(
            this.tradeService
              .getCapitalMarketOrders(this.currentContract)
              .subscribe(
                () => (this.isRefreshing = false),
                (err) => (this.isRefreshing = false),
              ),
          );
          break;
        case 1:
          this.subscriptions.add(
            this.tradeService.getFundsOrders(this.currentContract).subscribe(
              () => (this.isRefreshing = false),
              (err) => (this.isRefreshing = false),
            ),
          );
          break;
        case 2:
          this.subscriptions.add(
            this.tradeService.getCashOrders(this.currentContract).subscribe(
              () => (this.isRefreshing = false),
              (err) => (this.isRefreshing = false),
            ),
          );
          break;

        default:
          break;
      }

      setTimeout(() => {
        this.refreshIsDisabled = false;
      }, this.DISABLED_REFRESH_TIME);
    }
  }

  public downloadExcelFile() {
    switch (this.selectedTab) {
      case 0:
        this.downLoadExcel = this.downLoadExcel + 1;
        break;

      case 1:
        this.downLoadExcelFund = this.downLoadExcelFund + 1;
        break;

      case 2:
        this.downLoadExcelCash = this.downLoadExcelCash + 1;
        break;

      default:
        break;
    }
  }
}
